<template>
  <div class="ArrayColorSelector">
    <div class="p-line"></div>
    <el-popover placement="bottom" :width="170" trigger="click" popper-class="array-color-selector-poper">
      <template #reference>
        <div class="array-color-selector">
          <span class="p-name">配色方案</span
          ><span class="p-array">
            <div
              class="color-block"
              v-for="item in colorArray"
              :key="item"
              :style="{
                backgroundColor: item,
              }"
            ></div>
          </span>
        </div>
      </template>
      <div class="multi-color-selector">
        <ul>
          <li
            class="multi-color-selector-item"
            v-for="(item, index) in multiColorArray"
            :key="index"
            @click="selectColor(item)"
          >
            <span class="color-check" :class="{ 'el-icon-check': judeselected(item) }"></span>
            <span class="p-array">
              <div
                class="color-block"
                v-for="item2 in item"
                :key="item2"
                :style="{
                  backgroundColor: item2,
                }"
              ></div>
            </span>
          </li>
        </ul>
      </div>
    </el-popover>
    <div class="manual-color-array">
      <div class="manual-color-array-label">自定义配色方案</div>
      <div class="manual-color-array-body">
        <div class="editable-color-array-block">
          <div
            class="editable-color-block"
            @click="handelSelectedEditableColor(item, index)"
            :class="{
              active: item === editingColor && index === editingColorIndex,
            }"
            v-for="(item, index) in editingColorArray"
            :key="item"
            :style="{
              backgroundColor: item,
            }"
          ></div>
        </div>
      </div>
    </div>
    <div class="manual-color-picker">
      <div class="manual-color-picker-name">自定义配色选择颜色</div>
      <div class="manual-color-picker-body">
        <div class="manual-color-picker-btn el-icon-plus" @click="addColor"></div>
        <el-color-picker
          size="medium"
          @change="handleChange"
          show-alpha
          popper-class="ArrayColorSelector"
          v-model="editingColor"
        ></el-color-picker>
        <div class="manual-color-picker-btn el-icon-delete" @click="deleColor"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ArrayColorSelector',
  /*  prop属性只读 不可直接修改 会影响性能以及维护性 */
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  data() {
    return {
      chartColor: [],
      chartBackgroundColor: '',

      colorArray: ['#00ffff', '#14ff00', '#00e98c', '#222e39'],
      multiColorArray: [
        [
          'rgba(223,65,56,1)',
          'rgba(229,115,63,1)',
          'rgba(240,189,108,1)',
          'rgba(237,214,102,1)',
          'rgba(77,168,222,1)',
          'rgba(25,168,164,1)',
          'rgba(34, 46, 57, 0.04)',
        ],
        [
          'rgba(254, 128, 205, 1)',
          'rgba(30, 252, 122, 1)',
          'rgba(63, 210, 239, 1)',
          'rgba(237,214,102,1)',
          'rgba(77,168,222,1)',
          'rgba(25,168,164,1)',
          'rgba(34, 46, 57, 0.39)',
        ],
        [
          'rgba(0, 255, 255, 1)',
          'rgba(20, 255, 0, 1)',
          'rgba(0, 233, 140, 1)',
          'rgba(237,214,102,1)',
          'rgba(77,168,222,1)',
          'rgba(25,168,164,1)',
          'rgba(34, 46, 57, 1)',
        ],
        [
          'rgba(6, 154, 255, 1)',
          'rgba(255, 0, 201, 1)',
          'rgba(255, 83, 141, 1)',
          'rgba(237,214,102,1)',
          'rgba(77,168,222,1)',
          'rgba(25,168,164,1)',
          'rgba(39, 39, 69, 1)',
        ],
        [
          'rgba(198, 230, 241, 1)',
          'rgba(121, 237, 187, 1)',
          'rgba(98, 211, 225, 1)',
          'rgba(237,214,102,1)',
          'rgba(77,168,222,1)',
          'rgba(25,168,164,1)',
          'rgba(70, 86, 103, 1)',
        ],
        [
          'rgba(234, 150, 184, 1)',
          'rgba(186, 74, 146, 1)',
          'rgba(232, 191, 93, 1)',
          'rgba(237,214,102,1)',
          'rgba(77,168,222,1)',
          'rgba(25,168,164,1)',
          'rgba(18, 25, 43, 1)',
        ],
        [
          'rgba(1, 14, 37, 1)',
          'rgba(1, 14, 37, 1)',
          'rgba(1, 14, 37, 1)',
          'rgba(1, 14, 37, 1)',
          'rgba(1, 14, 37, 1)',
          'rgba(1, 14, 37, 1)',
          'rgba(0,0,0,0)',
        ],
      ],
      editingColor: '',
      editingColorArray: ['#00ffff', '#14ff00', '#00e98c', '#222e39'],
      editingColorIndex: 0,
    };
  },
  created() {},
  watch: {
    colorArray: {
      deep: true,
      handler: function (val) {
        this.editingColorArray = val;
      },
    },
    editingColorArray: {
      deep: true,
      handler: function (val) {
        this.colorArray = val;
        this.chartBackgroundColor = this.colorArray[this.colorArray.length - 1];
        let temp = this.$_.cloneDeep(this.colorArray);
        temp.splice(this.colorArray.length - 1, 1);
        this.chartColor = temp;
        this.updateConfiguration();
      },
    },
  },
  mounted() {
    /* 获取初始值 */

    this.initValue();
    if (this.editingColorArray[this.editingColorIndex]) {
      this.editingColor = this.editingColorArray[this.editingColorIndex];
    }
  },
  methods: {
    initValue() {
      let bk = this.propertyData[this.propertyDataKey].value.chartBackgroundColor;
      let cr = this.propertyData[this.propertyDataKey].value.chartColor;
      this.colorArray = [...cr, bk];
    },
    updateConfiguration() {
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: {
          chartColor: this.chartColor,
          chartBackgroundColor: this.chartBackgroundColor,
        },
      });
    },
    judeselected(colorArray) {
      let str = colorArray.toString();
      let str2 = this.colorArray.toString();
      if (str === str2) {
        return true;
      }
      return false;
    },
    selectColor(colorArray) {
      this.colorArray = this.$_.cloneDeep(colorArray);
      this.chartBackgroundColor = this.colorArray[this.colorArray.length - 1];
      let temp = this.$_.cloneDeep(this.colorArray);
      temp.splice(this.colorArray.length - 1, 1);
      this.chartColor = temp;
      this.updateConfiguration();
      console.log(this.chartColor);
      console.log(this.chartBackgroundColor);
    },
    handleChange(val) {
      console.log(val);
      if (this.editingColorArray[this.editingColorIndex]) {
        this.editingColorArray[this.editingColorIndex] = val;
      }
    },
    handelSelectedEditableColor(color, index) {
      this.editingColor = color;
      this.editingColorIndex = index;
    },
    addColor() {
      if (this.editingColorArray.length > 10) {
        this.$ElMessage.error('已达到最大配色颜色！');
        return;
      }
      this.editingColorArray.push('#fff');
    },
    deleColor() {
      if (this.editingColorArray.length < 5) {
        this.$ElMessage.error('已达到最小配色颜色！');
        return;
      }
      if (this.editingColorIndex === 'none') {
        return;
      }
      this.editingColorArray.splice(this.editingColorIndex, 1);
      this.editingColorIndex = 'none';
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
body {
  .el-popover.array-color-selector-poper {
    background: #2a2c3c;
    border: 0px;
    border-radius: 10px;
    ul,
    li {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      width: 100%;
      margin: 5px 0;
      color: white;
      .p-array {
        width: 80%;
        flex-shrink: 0;
        flex-grow: 0;
        display: flex;
        margin-left: 10px;
        border: 1px solid #5d5d61;
        padding: 1px;
        &:hover {
          border: 1px solid #696df4;
        }
        .color-block {
          flex-shrink: 1;
          width: 34px;
          height: 14px;
          box-sizing: border-box;
          border-right: 1px solid rgb(0, 0, 0);
        }
        .color-block:last-child {
          border-right: 0px;
        }
      }
    }
    ul {
      width: 100%;
      display: flex;
      flex-direction: column;
    }
    & .el-popper__arrow::before {
      background: #2a2c3c;
      border: 0px;
    }
  }
}
</style>

<style scoped lang="scss">
.ArrayColorSelector {
  margin-top: 15px;
  width: 100%;
  box-sizing: border-box;
  .p-line {
    width: 100%;
    height: 1px;
    background-image: linear-gradient(
      to left,
      rgba(204, 204, 204, 0),
      rgb(143, 143, 143),
      rgba(204, 204, 204, 0)
    );
    margin-bottom: 5px;
  }
  .array-color-selector {
    width: 100%;
    padding: 0 15px;
    height: 40px;
    display: flex;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    color: $property-title-color;
    font-size: $property-title-size;
    span {
      padding: 0;
      margin: 0;
    }
    .p-array {
      max-width: 174px;
      display: flex;
      flex-grow: 0;
      margin-left: 10px;
      border: 1px solid #909098;
      padding: 1px;
      &:hover {
        border: 1px solid #696df4;
      }
      .color-block {
        flex-shrink: 1;
        width: 34px;
        height: 14px;
        box-sizing: border-box;
        border-right: 1px solid rgb(0, 0, 0);
      }
      .color-block:last-child {
        border-right: 0px;
      }
    }
  }
  .manual-color-array {
    margin-top: 20px;
    width: 100%;
    .manual-color-array-label {
      width: 100%;
      padding: 0 15px;

      box-sizing: border-box;
      color: $property-title-color;
      font-size: $property-title-size;
    }
    .manual-color-array-body {
      margin-top: 10px;
      width: 100%;
      padding: 0 15px;
      box-sizing: border-box;
      .editable-color-array-block {
        display: flex;
        border: 1px solid #909098;
        padding: 1px;
        &:hover {
          border: 1px solid #696df4;
        }
      }
      .editable-color-block {
        flex-shrink: 1;
        width: 100%;
        // width: 36px;
        height: 16px;
        box-sizing: border-box;
        border-right: 1px solid rgb(0, 0, 0);
        position: relative;
      }
      .active {
        position: relative;
        border: 2px solid #44b4ff !important;
        &::after {
          position: absolute;
          content: '';
          border: 5px solid #44b4ff;
          border-top: 5px solid rgba(255, 255, 255, 0);
          border-left: 5px solid rgba(255, 255, 255, 0);
          border-right: 5px solid rgba(255, 255, 255, 0);
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
      .editable-color-block:last-child {
        border-right: 0px;
      }
    }
  }
  .manual-color-picker {
    margin-top: 15px;
    width: 100%;
    .manual-color-picker-name {
      width: 100%;
      padding: 0 15px;
      font-size: 12px;
      text-align: center;
      box-sizing: border-box;
      color: $property-attributes-color;
    }
    .manual-color-picker-body {
      margin-top: 15px;
      display: flex;
      align-items: center;
      justify-content: space-around;

      .manual-color-picker-btn {
        font-size: 15px;
        font-weight: 600;
        color: $font-color-base;
        text-align: center;
        width: 30px;
        line-height: 30px;
        height: 30px;
        border-radius: 2px;
        cursor: pointer;
        background: #2c2e3f;
        &:hover {
          background: linear-gradient(143deg, #335ae9, #6f6ff5);
          color: white;
        }
      }
    }
  }
}
</style>
